import React from 'react'
import { HelpCircle } from 'lucide-react'
import { useScreenHelp } from '../../hooks/useScreenHelp'

/**
 * Help button — only rendered when published CMS content exists for the screen.
 */
export default function HelpScreenButton({ screenKey, onClick, className = '' }) {
  const { hasHelp, loading } = useScreenHelp(screenKey)
  if (loading || !hasHelp) return null

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-semibold border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 shadow-sm ${className}`}
      aria-label="Open screen help"
      title="Screen help"
    >
      <HelpCircle size={16} className="text-teal-700" />
      <span className="hidden sm:inline">Help</span>
    </button>
  )
}
